const CF_CONNECTING_IP = 'cf-connecting-ip';
const CONSTRUCTOR_SESSION_ID = 'ConstructorioID_session_id';
const CONSTRUCTOR_CLIENT_ID = 'ConstructorioID_client_id';

export const getConstructorNodeClientUserParams = (req) => {
  const cookies = req?.cookies;

  const sessionId = cookies?.[CONSTRUCTOR_SESSION_ID] || '';
  const clientId = cookies?.[CONSTRUCTOR_CLIENT_ID] || '';
  const userAgent = req?.headers?.['user-agent'] || '';
  const userIp = req?.headers?.[CF_CONNECTING_IP] || '';

  return {
    ...(sessionId && { sessionId }),
    ...(clientId && { clientId }),
    ...(userAgent && { userAgent }),
    ...(userIp && { userIp }),
  };
};
